<div (mouseleave)="popover.close()">
  <div #popover="ngbPopover" [ngbPopover]="popoverRef" [autoClose]="'outside'">
    <div
      class="btn btn-icon btn-light btn-icon-muted btn-active-light btn-active-color-primary"
    >
      <ui-keenicon
        [name]="
          {
            dark: 'moon',
            light: 'night-day',
            system: 'screen',
          }[menuMode()]
        "
        class="fs-2 fs-lg-1 theme-light-hide svg-icon-2"
      ></ui-keenicon>
    </div>
  </div>
  <ng-template #popoverRef>
    <div
      class="popover-fix menu menu-column menu-rounded menu-title-gray-700 menu-icon-muted menu-active-bg menu-state-primary fw-semibold py-4 fs-base w-175px"
      data-kt-menu="true"
    >
      @for (mode of ['light', 'dark']; track mode) {
        <div class="menu-item px-3 my-0">
          <a
            class="menu-link px-3 py-2"
            [ngClass]="{ active: menuMode() === mode }"
            (click)="switchMode(mode)"
            (keyup.enter)="switchMode(mode)"
            tabindex="0"
            role="button"
          >
            <span class="menu-icon" data-kt-element="icon">
              <ui-keenicon
                [name]="
                  {
                    light: 'night-day',
                    dark: 'moon',
                    system: 'screen',
                  }[mode]!
                "
                class="fs-3"
              ></ui-keenicon>
            </span>
            <span class="menu-title">{{ mode | titlecase }}</span>
          </a>
        </div>
      }
    </div></ng-template
  >
</div>
